import { Link } from 'react-router-dom';
import SectionTitle from '@/components/feature/SectionTitle';
import { collections } from '@/mocks/collections';
import { formatDate } from '@/lib/content';

export default function CollectionsSection() {
  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <SectionTitle
          eyebrow="推荐专题"
          title="剧情分析与幕后花絮"
          description="围绕《迷人的保姆》的剧情脉络、角色解读与幕后故事，帮助观众更深入地理解这部剧。"
          linkTo="/about"
          linkLabel="更多内容说明"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {collections.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-accent-300 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={item.title}
                  title={`${item.title} - 迷人的保姆专题`}
                  className="w-full h-full object-top object-cover group-hover:scale-105 transition-transform duration-700"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-[11px] font-medium bg-accent-500 text-background-50 dark:text-foreground-950">
                  {item.category}
                </span>
              </div>
              <div className="flex flex-col flex-1 p-4">
                <h3 className="font-semibold text-foreground-950 group-hover:text-accent-700 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed flex-1">{item.excerpt}</p>
                <div className="mt-4 flex items-center justify-between text-[11px] text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-calendar-line"></i>
                    {formatDate(item.date)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    阅读约 {item.readTime}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}